export const LAST_VERIFICATION_DETAILS_SUBMISSION_TIME_KEY = 'LAST_VERIFICATION_DETAILS_SUBMISSION_TIME_KEY';
export const FUTURE_BOOKING_LIMIT_SWITCH = 'pro_settings_limit_future_availability_ev4355_20230831';
export const AVAILABILITY_DROP_SWITCH = 'pro_settings_availability_drop_ev4357_20230926';
export const SHOW_NEW_PREMIUM_CTA_PLAN_SETTINGS_SWITCH = 'show_new_premium_cta_plan_settings_ev4609_20240120';
